// src/components/common/Logo.js
import { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import config from "../../config/config";

// Importing static images (fallbacks)
import primarylogo from "../../images/logo-p.svg";
import primarylogoicon from "../../images/logo-icon.png";
import secondarylogo from "../../images/turning-point-w-powered-by.png";
import secondarylogowhite from "../../images/turning-point-w-powered-by-white.png";
import primarylogodash from "../../images/logo-p.svg";


// Centralized fallback logo paths
const fallbackLogos = {
  primary: primarylogo,
  primaryIcon: primarylogoicon,
  secondary: secondarylogo,
  secondaryWhite: secondarylogowhite,
  primaryDash: primarylogodash,
};

// Joins a base URL and a path with exactly one slash between them,
// regardless of whether either side already has one — e.g. a base URL
// with a trailing slash (some env configs have one, some don't) combined
// with a theme-provided path that already starts with "/" would otherwise
// produce "https://host///path", which 404s rather than normalizing.
const joinUrl = (base, path) => `${String(base).replace(/\/+$/, "")}/${String(path).replace(/^\/+/, "")}`;

export function Logo({ type = "primary", size = 100, className = "", withLink = false }) {
  const theme = useContext(ThemeContext);

  // If theme.logo is set, use it dynamically from backend/CDN
  let logoSrc;
  if (theme?.logo && type === "primary") {
    logoSrc = joinUrl(config.assetsBaseUrl, theme.logo);
  } else if (theme?.logo_dash && type === "primaryDash") {
    logoSrc = joinUrl(config.assetsBaseUrl, theme.logo_dash);
  } else {
    // Otherwise use the fallback static logos
    logoSrc = fallbackLogos[type] || fallbackLogos.primary;
  }

  const logo = (
    <img
      src={logoSrc}
      alt={`${type} logo`}
      width={size}
      height="auto"
      className={`object-contain ${className}`}
    />
  );

  return withLink ? <a href="/">{logo}</a> : logo;
}

export default Logo;
